interface TypeBadgeProps {
  kind: "photo" | "video";
  isAnimated?: boolean;
}

export function TypeBadge({ kind, isAnimated }: TypeBadgeProps) {
  const isVideo = kind === "video";
  let bg: string;
  let label: string;
  if (isAnimated && !isVideo) {
    bg = "bg-amber-600";
    label = "GIF";
  } else if (isVideo) {
    bg = "bg-sky-600";
    label = "Video";
  } else {
    bg = "bg-emerald-600";
    label = "Photo";
  }
  return (
    <span
      className={
        "absolute right-1.5 top-1.5 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-white shadow " +
        bg
      }
    >
      {label}
    </span>
  );
}
